import { z } from 'zod'

export const agentTagsSchema = z
  .array(
    z
      .string()
      .trim()
      .toLowerCase()
      .min(1)
      .max(64)
      .regex(/^[a-zA-Z0-9_.-]+$/),
  )
  .max(32)
  .transform((tags) => [...new Set(tags)].sort())
export const agentTargetSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('instance'), agentId: z.string().uuid() }).strict(),
  z
    .object({ kind: z.literal('tags'), tags: agentTagsSchema.refine((tags) => tags.length > 0) })
    .strict(),
])
export const executionTargetSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('saas') }).strict(),
  z.object({ mode: z.literal('agent'), target: agentTargetSchema }).strict(),
])
export const probeExecutionSchema = z.union([
  executionTargetSchema,
  z.object({ mode: z.literal('inherit') }).strict(),
])
export type ExecutionTarget = z.infer<typeof executionTargetSchema>
export type ProbeExecution = z.infer<typeof probeExecutionSchema>
export type AgentTarget = z.infer<typeof agentTargetSchema>
